export enum EntityTypes {
  Customers = 'customers',
  Vendors = 'vendors',
  Consignments = 'consignments',
  Zones = 'zones',
  VendorServices = 'vendorServices',
}
